import {
  getCancellableSubscriptionCard,
  getCancelSurveySubscriptionType,
  getSubscriptionCards,
} from '@griply/utils';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useUser } from 'shared/hooks/use-user';

export const useCancellableSubscriptionCard = () => {
  const user = useUser();
  const today = useToday();

  return useMemo(() => {
    const cards = getSubscriptionCards(user?.subscriptions, today);
    const card = getCancellableSubscriptionCard(cards);

    return {
      card,
      variant: card ? getCancelSurveySubscriptionType(card) : null,
    };
  }, [user?.subscriptions, today]);
};
